
const JapanFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
            <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="#F5F5F5" strokeWidth="0.5" />
            <mask id="mask0_1325_7501" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="17">
                <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="white" strokeWidth="0.5" />
            </mask>
            <g mask="url(#mask0_1325_7501)">
                <path fillRule="evenodd" clipRule="evenodd" d="M11.4999 13.3002C14.1036 13.3002 16.2142 11.1512 16.2142 8.5002C16.2142 5.84923 14.1036 3.7002 11.4999 3.7002C8.8963 3.7002 6.78564 5.84923 6.78564 8.5002C6.78564 11.1512 8.8963 13.3002 11.4999 13.3002Z" fill="url(#paint0_linear_1325_7501)" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_1325_7501" x1="6.78564" y1="3.7002" x2="6.78564" y2="13.3002" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#D81441" />
                    <stop offset="1" stopColor="#BB0831" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default JapanFlag